
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 28 28","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.61 4.119c-.213.637-.698 1.139-1.286 1.466-.09.05-.181.103-.27.157-.578.346-1.256.516-1.915.381l-1.402-.286a2.333 2.333 0 00-2.489 1.119L2.524 8.21a2.333 2.333 0 00.275 2.714l.95 1.073c.446.502.639 1.172.628 1.844-.002.105-.002.21 0 .316.01.672-.182 1.342-.627 1.844l-.951 1.072a2.333 2.333 0 00-.275 2.715l.724 1.255a2.333 2.333 0 002.489 1.12l1.402-.288c.66-.135 1.337.036 1.914.382.09.054.18.106.271.157.588.327 1.073.829 1.286 1.466l.452 1.357a2.333 2.333 0 002.214 1.595h1.449a2.333 2.333 0 002.213-1.595l.452-1.357c.213-.637.698-1.139 1.286-1.466.091-.05.182-.103.271-.157.577-.346 1.255-.517 1.914-.382l1.402.287a2.333 2.333 0 002.489-1.119l.724-1.255a2.333 2.333 0 00-.275-2.715l-.95-1.072c-.446-.502-.639-1.172-.628-1.844.002-.105.002-.21 0-.316-.01-.672.182-1.342.628-1.844l.95-1.073a2.333 2.333 0 00.275-2.714l-.724-1.255a2.333 2.333 0 00-2.489-1.12l-1.402.287c-.66.135-1.337-.035-1.914-.381a9.555 9.555 0 00-.271-.157c-.588-.327-1.073-.829-1.286-1.466l-.452-1.357a2.333 2.333 0 00-2.213-1.595h-1.45a2.333 2.333 0 00-2.213 1.595L10.61 4.12zM17.5 14a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z"}})])
          )
        }
      }
    